
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetolavasacab() {



    const cardData =
    {
        keyword: 'Pune to Lavasa Cab',
        heading: 'Meghana Cab : Pune to Lavasa Cab',
        headingDescription: 'Meghana Cab offers Pune to Lavasa Cab services, perfect for a peaceful getaway to the scenic hill city. Whether you’re planning a one-day trip, a weekend retreat, or a romantic escape, our well-maintained cabs and courteous drivers ensure a smooth, safe, and comfortable ride. With flexible pickup times, competitive pricing, and 24/7 customer support, your travel to Lavasa becomes easy and stress-free. Book your Pune to Lavasa Cab with Meghana Cab and experience a refreshing journey amidst nature.',


        top: 'Top Places to Visit in Lavasa with Meghana Cab',

"topPlaces": [
  {
    "title": "Lakeside Promenade",
    "description": "The Lakeside Promenade is the heart of Lavasa, offering scenic views of the Warasgaon Lake. This waterfront stretch is lined with cafes, restaurants, and boutique shops, making it perfect for a relaxing walk, lakeside dining, or cycling along the path. The European-style architecture and colorful facades add to the charm, especially during sunset."
  },
  {
    "title": "Temghar Dam",
    "description": "Located en route to Lavasa, Temghar Dam is an excellent pitstop known for its lush surroundings and impressive structure. It supplies water to Lavasa and offers a panoramic view of the reservoir and mountains. During monsoons, the dam overflows create a misty, serene landscape that attracts travelers and photographers."
  },
  {
    "title": "Adventure Sports Zone",
    "description": "Lavasa offers a wide range of outdoor adventure activities such as zip-lining, rock climbing, rappelling, paintball, and jungle treks. For thrill seekers, these experiences are professionally managed and set in picturesque natural settings, offering the perfect blend of excitement and nature."
  },
  {
    "title": "Bamboosa",
    "description": "Bamboosa is a unique bamboo crafts center in Lavasa where visitors can witness the process of bamboo product manufacturing and shop for eco-friendly items. It supports local employment and offers a blend of art, sustainability, and rural entrepreneurship — making it a meaningful stop for socially conscious tourists."
  },
  {
    "title": "Lavasa Nature Trails",
    "description": "Surrounded by the Sahyadri hills, Lavasa offers well-marked nature trails that range from easy to moderate difficulty. These trails pass through dense forests, open valleys, and streams, making them ideal for nature lovers, photographers, and bird watchers, especially in early mornings."
  },
  {
    "title": "E-Bike and Segway Rides",
    "description": "Tourists can explore Lavasa on electric bikes and Segways, which are available on rent near the promenade. This fun, eco-friendly transportation method allows visitors to cover more ground while enjoying the fresh air and picturesque views."
  },
  {
    "title": "Watersports at Warasgaon Lake",
    "description": "The lake in Lavasa offers water-based activities like kayaking, boating, water scooters, and jet skiing. These activities are managed under strict safety guidelines and provide a refreshing break with stunning backdrops of hills and clouds."
  },
  {
    "title": "Xthrill Adventure Academy",
    "description": "Situated near Lavasa, Xthrill is an outdoor adventure park offering tent stays, rope courses, obstacle activities, and team-building programs. It’s ideal for corporate groups, school outings, and anyone looking for an offbeat wilderness experience in a safe environment."
  },
  {
    "title": "Dasve Viewpoint",
    "description": "Offering a bird’s-eye view of Lavasa city and the valley below, Dasve Viewpoint is a scenic location for photography and reflection. The point offers unobstructed views of the Warasgaon Lake surrounded by green hills, especially magical at sunrise or just after rainfall."
  },
  {
    "title": "Temples and Meditation Zones",
    "description": "Lavasa includes small yet serene temples and meditation areas surrounded by nature. These peaceful spaces are ideal for introspection and spiritual retreat, especially for visitors looking for a quiet escape from urban chaos."
  }
],

"services": [
    {
        "name": "Pune to Lavasa Cab Booking",
        "description": "Book reliable and comfortable cabs from Pune to Lavasa with Meghana Cab. Enjoy smooth rides with professional drivers, perfect for solo travelers and groups heading to Lavasa."
    },
    {
        "name": "One Way Taxi to Lavasa from Pune",
        "description": "Travel one way from Pune to Lavasa hassle-free with Meghana Cab. Our timely pickups and clean vehicles ensure a pleasant journey to this beautiful hill city."
    },
    {
        "name": "AC Cab for Pune to Lavasa Trip",
        "description": "Stay cool and comfortable during your Pune to Lavasa trip with Meghana Cab’s air-conditioned cabs, ideal for warm weather and long-distance travel."
    },
    {
        "name": "Pune to Lavasa SUV Rental",
        "description": "Opt for a spacious and powerful SUV rental from Pune to Lavasa. Meghana Cab offers SUVs perfect for families and groups seeking comfort and extra luggage space."
    },
    {
        "name": "Round Trip Taxi to Lavasa",
        "description": "Plan a convenient round trip from Pune to Lavasa with Meghana Cab’s flexible taxi services. Enjoy stress-free travel with easy scheduling and affordable fares."
    },
    {
        "name": "Sedan Hire Pune to Lavasa",
        "description": "Choose from our comfortable sedan options for Pune to Lavasa travel. Meghana Cab provides well-maintained sedans suitable for small groups or solo travelers."
    },
    {
        "name": "Book Lavasa Sightseeing Cab from Pune",
        "description": "Explore the scenic beauty of Lavasa with Meghana Cab’s sightseeing cabs. Our drivers are knowledgeable about local attractions to enhance your trip."
    },
    {
        "name": "Online Cab Booking Pune to Lavasa",
        "description": "Easily book your Pune to Lavasa cab online with Meghana Cab’s user-friendly platform. Quick confirmation and reliable service for your convenience."
    },
    {
        "name": "Weekend Getaway Cab Pune to Lavasa",
        "description": "Plan a perfect weekend getaway from Pune to Lavasa with Meghana Cab. Comfortable rides and flexible timings to suit your leisure travel plans."
    },
    {
        "name": "Family Trip Cab to Lavasa from Pune",
        "description": "Travel with your family in comfort by hiring a cab from Pune to Lavasa. Meghana Cab offers spacious vehicles and safe driving for your family outing."
    },
    {
        "name": "Budget Travel Cab Pune to Lavasa",
        "description": "Looking for affordable travel options from Pune to Lavasa? Meghana Cab provides budget-friendly cabs without compromising on comfort or service quality."
    },
    {
        "name": "24/7 Cab Pune to Lavasa",
        "description": "Avail 24/7 cab services from Pune to Lavasa with Meghana Cab. Whether it’s an early morning or late-night trip, we are always ready to serve you."
    },
    {
        "name": "Pune to Lavasa Taxi Fare",
        "description": "Get transparent and competitive taxi fare estimates for your Pune to Lavasa trip with Meghana Cab. No hidden charges, just honest pricing."
    },
    {
        "name": "Chauffeur Service Pune to Lavasa",
        "description": "Hire professional chauffeurs for your Pune to Lavasa journey. Meghana Cab’s drivers are courteous, experienced, and knowledgeable about the route."
    },
    {
        "name": "Outstation Cab Pune to Lavasa",
        "description": "Book outstation cabs for Pune to Lavasa travel with Meghana Cab. Perfect for long-distance trips ensuring safety, comfort, and timely arrivals."
    }
],

"tableData": [
    ["Pune to Lavasa Cab Booking", "One Way Taxi to Lavasa from Pune"],
    ["AC Cab for Pune to Lavasa Trip", "Pune to Lavasa SUV Rental"],
    ["Round Trip Taxi to Lavasa", "Sedan Hire Pune to Lavasa"],
    ["Book Lavasa Sightseeing Cab from Pune", "Online Cab Booking Pune to Lavasa"],
    ["Weekend Getaway Cab Pune to Lavasa", "Family Trip Cab to Lavasa from Pune"],
    ["Budget Travel Cab Pune to Lavasa", "24/7 Cab Pune to Lavasa"],
    ["Pune to Lavasa Taxi Fare", "Chauffeur Service Pune to Lavasa"],
    ["Outstation Cab Pune to Lavasa", ""],
    ["", ""]
],











"whychoose": [
    {
        "WhyChooseheading": "Scenic and Comfortable Pune to Lavasa Cab Service",
        "WhyChoosedescription": "Meghana Cab offers a pleasant and hassle-free cab service from Pune to Lavasa. Whether it's a weekend getaway or a day trip, enjoy the scenic drive in our clean, comfortable, and air-conditioned cabs."
    },
    {
        "WhyChooseheading": "On-Time Pick-Up and Drop",
        "WhyChoosedescription": "We ensure timely pick-up and drop-off for your Pune to Lavasa journey. With Meghana Cab, you can make the most of your trip without worrying about delays."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Hill Station Travel",
        "WhyChoosedescription": "Our drivers are skilled and experienced in navigating hilly routes like the one to Lavasa. They ensure a safe, smooth, and enjoyable ride through the winding roads."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Cab Fare",
        "WhyChoosedescription": "Travel to Lavasa without stretching your budget. Meghana Cab offers competitive pricing with no hidden charges—what you see is what you pay."
    },
    {
        "WhyChooseheading": "Clean, Safe, and Sanitized Vehicles",
        "WhyChoosedescription": "All our vehicles are regularly sanitized, well-maintained, and equipped with safety features like GPS, seat belts, and first aid kits to ensure a secure travel experience."
    },
    {
        "WhyChooseheading": "24/7 Pune to Lavasa Cab Availability",
        "WhyChoosedescription": "Plan your trip to Lavasa anytime—early morning or late night. Meghana Cab provides 24/7 service for maximum flexibility and convenience."
    },
    {
        "WhyChooseheading": "Flexible Packages for One-Way or Round Trip",
        "WhyChoosedescription": "Whether you need a one-way drop or a round trip with waiting time, we offer customizable packages to suit your travel needs from Pune to Lavasa."
    },
    {
        "WhyChooseheading": "Easy Booking and Quick Customer Support",
        "WhyChoosedescription": "Book your Pune to Lavasa cab easily through our website or mobile app. Our customer support team is always available to assist with bookings and travel queries."
    }
]























    }

const faqData = [
    {
        question: "How can I book a Pune to Lavasa cab with Meghana Cab?",
        answer: "Booking a Pune to Lavasa cab is easy with Meghana Cab. You can book online via our website or call us directly at +91 9075462128."
    },
    {
        question: "What types of cabs are available for Pune to Lavasa travel?",
        answer: "Meghana Cab offers hatchbacks, sedans, SUVs, and tempo travellers to accommodate different group sizes and preferences."
    },
    {
        question: "How long does it take to travel from Pune to Lavasa by cab?",
        answer: "The journey from Pune to Lavasa typically takes around 1.5 to 2 hours depending on traffic and road conditions."
    },
    {
        question: "Is one-way cab service available from Pune to Lavasa?",
        answer: "Yes, Meghana Cab provides both one-way and round-trip cab services for the Pune to Lavasa route."
    },
    {
        question: "Are tolls and parking fees included in the fare?",
        answer: "Toll and parking charges are extra and will be communicated during the booking process."
    },
    {
        question: "Are Meghana Cab drivers familiar with the Pune to Lavasa route?",
        answer: "Yes, our drivers are experienced and well-acquainted with the best routes between Pune and Lavasa."
    },
    {
        question: "Can I request stops during the Pune to Lavasa trip?",
        answer: "Yes, you can request stops at scenic spots or other places along the route. Please inform us during booking."
    },
    {
        question: "Is the Pune to Lavasa cab service available 24/7?",
        answer: "Absolutely. Meghana Cab operates round the clock, so you can book your cab anytime."
    },
    {
        question: "What payment methods are accepted for Pune to Lavasa bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash for hassle-free payments."
    },
    {
        question: "How can I contact Meghana Cab to book a Pune to Lavasa cab?",
        answer: "You can reach Meghana Cab at +91 9075462128 for bookings and inquiries."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Sameer Deshpande',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Our Pune to Lavasa cab ride with Meghana Cab was excellent. The driver was punctual and the vehicle was clean and comfortable.”',
    },
    {
        name: 'Ms. Kavita More',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“I had a wonderful experience traveling from Pune to Lavasa with Meghana Cab. The booking was smooth and the driver was very professional.”',
    },
];

















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Lavasa Cab",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-lavasa-cab.jpg",
  "description": "Book Pune to Lavasa cab with Meghana Cabs for one-way and round trips. Choose from AC Sedans, SUVs, and budget-friendly options for sightseeing, family trips, and weekend getaways.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5199"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1100",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-lavasa-cab"
  }
};




    return (
        <div>


<Helmet>
  <title>Pune to Lavasa Cab | One Way & Round Trip | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Lavasa cab with Meghana Cabs for one-way and round trips. Choose from AC Sedans, SUVs, and budget-friendly options for sightseeing, family trips, and weekend getaways." 
  />
  <meta 
    name="keywords" 
    content="Pune to Lavasa Cab Booking, One Way Taxi to Lavasa from Pune, AC Cab for Pune to Lavasa Trip, Pune to Lavasa SUV Rental, Round Trip Taxi to Lavasa, Sedan Hire Pune to Lavasa, Book Lavasa Sightseeing Cab from Pune, Online Cab Booking Pune to Lavasa, Weekend Getaway Cab Pune to Lavasa, Family Trip Cab to Lavasa from Pune, Budget Travel Cab Pune to Lavasa, 24/7 Cab Pune to Lavasa, Pune to Lavasa Taxi Fare, Chauffeur Service Pune to Lavasa, Outstation Cab Pune to Lavasa" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/11.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetolavasacab;